import type { Fallacy } from "./types";
import { createStory } from "./types";

export const euphemismTreadmill: Fallacy = {
    id: "euphemism-treadmill",
    name: "Euphemism Treadmill",
    emoji: "🎩",
    category: "Jebakan Bahasa",
    description:
      "Menggunakan **bahasa halus** untuk menyamarkan kenyataan, sehingga masalah **terdengar lebih ringan** dari seharusnya.",
    tldr: "\"Penyesuaian harga\" = naik harga. Bahasa halus buat sembunyiin kenyataan.",
    detail:
      "Euphemism Treadmill adalah fenomena di mana **bahasa halus digunakan untuk mengaburkan realitas** yang tidak menyenangkan. Disebut 'treadmill' karena begitu eufemisme lama dipahami sebagai negatif, **eufemisme baru diciptakan menggantikannya**.\n\nContoh: \"Penyesuaian harga\" = naik harga, \"Relokasi\" = penggusuran, \"Pertumbuhan negatif\" = kerugian, \"Oknum\" = pelaku yang organisasinya menolak tanggung jawab.\n\nKenapa berbahaya? Karena **bahasa membentuk persepsi**. Ketika PHK disebut 'efisiensi', orang menerimanya sebagai hal wajar. Ketika penggusuran disebut 'relokasi', kekerasan di baliknya tak terlihat.\n\nCara mengenali: **Terjemahkan ke bahasa yang lebih langsung**. Kalau artinya berubah drastis, eufemisme sedang menyembunyikan sesuatu.",
    story: createStory("Euphemism Treadmill", "🎩", {
      hook: {
        title: "\"Penyesuaian harga\"",
        body: "Kedengerannya halus. Padahal artinya cuma satu: **naik harga**. Bahasa halus buat nutupin kenyataan.",
      },
      convo: {
        claim: "Temen-temen seruangan aku pada dipecat minggu ini. Tapi email HR bilangnya **\"program efisiensi organisasi\"** dan \"realignment sumber daya manusia\". Kedengerannya kayak project bagus.",
        response: "Ganti nama gak ganti kenyataan. **Itu tetap PHK.**",
      },
      reveal: {
        body: "Bahasa halus dipakai buat **mengaburkan realitas**. Begitu eufemisme lama ketahuan, **langsung diganti yang baru**. Kayak treadmill — jalan terus tapi gak ke mana-mana.",
      },
      insight: {
        title: "Kenapa bahaya?",
        body: "Karena **bahasa membentuk persepsi**. PHK disebut \"efisiensi\" jadi kedengeran wajar. Padahal yang terjadi tetap sama — orang kehilangan pekerjaan.",
      },
      engagement: {
        title: "Euphemism paling parah yang pernah kamu denger?",
        body: "Dari kantor atau dari pemerintah? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["framing-effect", "loaded-question", "red-herring"],
  };
